// Select all elements with the class 'swiper-reviews'
const swiperElements = document.querySelectorAll('.swiper-reviews');

// Loop through each element and initialize a Swiper instance
swiperElements.forEach((swiperElement) => {
  const swiper = new Swiper(swiperElement, {
    loop: true,
    spaceBetween: 15,
    effect: "fade",
    // If we need pagination
    pagination: {
      el: swiperElement.querySelector('.swiper-pagination'),
      clickable:true,
    },

    // Navigation arrows
    navigation: {
      nextEl: swiperElement.querySelector('.swiper-arrow-rev-next'),
      prevEl: swiperElement.querySelector('.swiper-arrow-rev-prev'),
    },

    breakpoints: {
      640: {
        spaceBetween: 24,
      }
    },
  });
});
